import appBookingsData from '../../../data/appBookings/appBookingsData.json';
import { format24HourTime } from '../../../utils/formatters';

export const formatTo24HourTime = format24HourTime;
export { format24HourTime };

export const getBusinessTitle = (booking) => {
    if (!booking) return 'N/A';
    if (booking.type === 'Task' || booking.type === 'Activity') {
        return (
            booking.business_id?.superadmin_activity_id?.name ||
            booking.business_id?.name ||
            booking.businessDetails?.activity_name ||
            booking.businessDetails?.business_name ||
            booking.business_id?.business_name ||
            booking.package_name ||
            'Activity Experience'
        );
    }
    return (
        booking.businessDetails?.business_name ||
        booking.business_id?.business_name ||
        booking.business_id?.name ||
        'Partner Business'
    );
};

export const getBusinessLocation = (booking) => {
    if (!booking) return '';
    if (booking.type === 'Task' || booking.type === 'Activity') {
        return (
            booking.businessDetails?.city ||
            booking.business_id?.city ||
            (Array.isArray(booking.business_id?.superadmin_activity_id?.city)
                ? booking.business_id?.superadmin_activity_id?.city[0]
                : booking.business_id?.superadmin_activity_id?.city) ||
            booking.business_id?.activity_id?.city ||
            'Srinagar'
        );
    }
    return (
        booking.businessDetails?.city ||
        booking.business_id?.city ||
        booking.business_id?.address ||
        'Srinagar'
    );
};

export const bookingGhostRows = appBookingsData.ghostRows;
export const bookingColumns = appBookingsData.columns;
